/*
 *
 * DisputeEntryModal
 *
 * @version 1.0.0
 * @author Alessandro Mancuso
 * @since 08-Apr-2026
 */

import React from 'react'
import PropTypes from 'prop-types'

// Components
import MerchantModal from '@nexidigital/merchantmodal'
import { Open } from '@nexidigital/iconlibrary'

// Utilities
import { openUrl } from 'Utility/globalMethods'
import linksConfig from '../../../../utils/linksConfig'

// Texts
import formattedMessage from './languageModule'

// Styles
import './DisputeEntryModal.scss'

const DisputeEntryModal = (props) => (
  <MerchantModal
    title={formattedMessage.title}
    isOpen
    onClose={() => props.actions.doHidePopup()}
    primaryButtonLabel={formattedMessage.continueButton}
    primaryIcon={<Open size='20' type='line' />}
    primaryAction={() => {
      props.actions.doHidePopup()
      openUrl(linksConfig.portale_esercenti, true)
    }}
  >
    <div className='disputeEntryModal'>
      <p>{formattedMessage.description}</p>
    </div>
  </MerchantModal>
)

DisputeEntryModal.propTypes = {
  actions: PropTypes.shape({
    doHidePopup: PropTypes.func
  })
}

DisputeEntryModal.defaultProps = {
  actions: {}
}

export default DisputeEntryModal
